const $49a81341a3c83fd9$var$GridArea = (children)=>({
        tag: "div",
        class: "grid__area",
        childProto: children,
        state: {
            selectedCells: []
        },
        on: {
            update: (el, state)=>{
                // Each time the number of selected cells gets updated, update the total selection component text
                const footerComponent = el.parent[2];
                const totalSelectionComponent = footerComponent.childProto[1];
                const totalSelected = state.selectedCells.length;
                // update component state
                totalSelectionComponent.state.update({
                    selectionTotal: totalSelected
                });
            }
        }
    });
var $49a81341a3c83fd9$export$2e2bcd8739ae039 = $49a81341a3c83fd9$var$GridArea;


const $312c426bcdb6f166$var$baseClass = "grid__cell ";
const $312c426bcdb6f166$var$selected = "selected";
const $312c426bcdb6f166$var$GridCell = ()=>({
        tag: "div",
        class: (elem, state)=>state.isSelected ? $312c426bcdb6f166$var$baseClass + $312c426bcdb6f166$var$selected : $312c426bcdb6f166$var$baseClass,
        // text: (elem, state) => elem.key,
        state: {
            isSelected: false,
            classList: $312c426bcdb6f166$var$baseClass,
            prevSelection: null
        },
        on: {
            click: (event, gridCell, state)=>{
                // Update the selected state for the current cell and all previous sibling cells
                const cellKey = parseInt(gridCell.key);
                const cellParent = gridCell.parent;
                const selectedCells = cellParent.state.selectedCells;
                const selectedCellsLength = cellParent.state.selectedCells.length;
                const currentKey = cellKey;
                // TODO:
                // Move the logic that handles updating the parent state into the on:{ update() }
                // So when the cell's isSelected state is updated, then add or remove it from the selectedCells parent array list.
                if (selectedCellsLength <= 1 && currentKey == 0) {
                    // if we have only 1 or less cells selected
                    $312c426bcdb6f166$var$updateState(state, "isSelected", !state.isSelected);
                    if (state.isSelected) // add to array list
                    $312c426bcdb6f166$var$updateState(cellParent.state, "selectedCells", [
                        currentKey
                    ]);
                    else {
                        // remove from array list
                        selectedCells.splice(currentKey, 1);
                        $312c426bcdb6f166$var$updateState(cellParent.state, "selectedCells", selectedCells);
                    }
                } else if (currentKey <= selectedCellsLength) {
                    // Handle deselection of cells because user has clicked a grid cell key than is less than the amount stored
                    for(let i = currentKey; i < selectedCellsLength + 1; i++)if (cellParent[i].state.isSelected) {
                        // if we have already selected grid cells then update their state to false and remove from array list
                        $312c426bcdb6f166$var$updateState(cellParent[i].state, "isSelected", false);
                        // remove cell from selected cells array
                        for(let ii = 0; ii < selectedCellsLength; ii++)if (selectedCells[ii] && selectedCells[ii] == cellParent[i].key) {
                            selectedCells.splice(ii, 1);
                            $312c426bcdb6f166$var$updateState(cellParent.state, "selectedCells", selectedCells);
                        }
                    }
                } else for(let i = selectedCellsLength; i < currentKey + 1; i++){
                    // work backwards updating the grid cell states until reaching the first cell item
                    $312c426bcdb6f166$var$updateState(cellParent[i].state, "isSelected", !cellParent[i].state.isSelected);
                    $312c426bcdb6f166$var$updateState(cellParent.state, "selectedCells", [
                        i,
                        ...selectedCells
                    ]);
                }
                /**
       * Update selection co-ordinates
       */ const selectionCoordsComponent = cellParent.parent.parent[2].childProto[0];
                const { row: row, column: column } = $312c426bcdb6f166$var$calculateRowAndColumn(cellKey) // offset the key by 1 due to the keys starting from 0.
                ;
                selectionCoordsComponent.state.update({
                    coordinates: [
                        row + 1,
                        column + 1
                    ]
                });
            }
        }
    });
function $312c426bcdb6f166$var$updateState(state, keyString, value) {
    state.update({
        [keyString]: value
    });
}
function $312c426bcdb6f166$var$calculateRowAndColumn(cellKey, columns = 16) {
    const row = Math.floor(cellKey / columns);
    const column = cellKey % columns;
    return {
        row: row,
        column: column
    };
}
var $312c426bcdb6f166$export$2e2bcd8739ae039 = $312c426bcdb6f166$var$GridCell;



const $0a86f6d69d6aa832$var$GridArea = (children)=>({
        tag: "div",
        class: "grid__footer",
        childProto: children
    });
var $0a86f6d69d6aa832$export$2e2bcd8739ae039 = $0a86f6d69d6aa832$var$GridArea;


const $4d894c0568f6ab6a$var$childComponents = [];
const $4d894c0568f6ab6a$var$rows = 8;
const $4d894c0568f6ab6a$var$cols = 16;
const $4d894c0568f6ab6a$var$gridAreaContent = [];
for(let i = 0; i < $4d894c0568f6ab6a$var$rows; i++)for(let ii = 0; ii < $4d894c0568f6ab6a$var$cols; ii++)$4d894c0568f6ab6a$var$gridAreaContent.push((0, $312c426bcdb6f166$export$2e2bcd8739ae039)());
const $4d894c0568f6ab6a$var$title = {
    tag: "h1",
    class: "title",
    text: "Grid Selection"
};
const $4d894c0568f6ab6a$var$gridArea = (0, $49a81341a3c83fd9$export$2e2bcd8739ae039)($4d894c0568f6ab6a$var$gridAreaContent);
const $4d894c0568f6ab6a$var$coordinatesSpan = {
    tag: "span",
    class: "value",
    text: (el, state)=>{
        return `${el.parent.state.coordinates[0]}, ${el.parent.state.coordinates[1]}`;
    }
};
const $4d894c0568f6ab6a$var$selectionCoordsComponent = {
    tag: "p",
    class: "selection_coordinates",
    text: (elem, state)=>{
        return "Selection coordinates:";
    },
    childProto: $4d894c0568f6ab6a$var$coordinatesSpan,
    state: {
        coordinates: [
            0,
            0
        ]
    }
};
const $4d894c0568f6ab6a$var$selectionTotal = {
    tag: "span",
    class: "value",
    text: (el, state)=>{
        return el.parent.state.selectionTotal;
    }
};
const $4d894c0568f6ab6a$var$totalSelectionComponent = {
    tag: "p",
    class: "selection_total",
    text: (elem, state)=>{
        return "Total cells selected:";
    },
    childProto: $4d894c0568f6ab6a$var$selectionTotal,
    state: {
        selectionTotal: 0
    }
};
const $4d894c0568f6ab6a$var$footerContent = [
    $4d894c0568f6ab6a$var$selectionCoordsComponent,
    $4d894c0568f6ab6a$var$totalSelectionComponent
];
$4d894c0568f6ab6a$var$childComponents.push($4d894c0568f6ab6a$var$title, $4d894c0568f6ab6a$var$gridArea, (0, $0a86f6d69d6aa832$export$2e2bcd8739ae039)($4d894c0568f6ab6a$var$footerContent));
const $4d894c0568f6ab6a$var$Grid = ()=>({
        tag: "div",
        class: "grid",
        childProto: $4d894c0568f6ab6a$var$childComponents
    });
var $4d894c0568f6ab6a$export$2e2bcd8739ae039 = $4d894c0568f6ab6a$var$Grid;


"use strict";
const $0961ea6318004278$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $0961ea6318004278$export$6f8fb29fbb5b5b63 = $0961ea6318004278$export$3a7728e868aa3ebd;


"use strict";
const $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4 = "production";
const $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "production" || env === "prod" || env !== "development" && env !== "dev" && env !== "test";
const $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "test";
const $e6d79d7b0d7b5fe1$export$df77466336fe5355 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "development" || env === "dev";
const $e6d79d7b0d7b5fe1$export$d84272657cb7c466 = (key, env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env[key];


"use strict";
const $e33f3b456b841cc9$export$90b4d2ff6acb88af = globalThis;
const $e33f3b456b841cc9$export$82c2e460fb230c2a = globalThis;
const $e33f3b456b841cc9$export$8291e5b88f90ce4 = globalThis;
const $e33f3b456b841cc9$export$5a7bfc01df82fcd1 = $e33f3b456b841cc9$export$8291e5b88f90ce4.document // eslint-disable-line
;


"use strict";
const $95800a96be489797$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === "object" ? obj instanceof (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).Node : obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string") || false;
};
const $95800a96be489797$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === "object" ? obj instanceof (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).HTMLElement // DOM2
     : obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string") || false;
};


"use strict";
const $079873fc3f2b5f81$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object" && arg.constructor === Object;
};
const $079873fc3f2b5f81$export$844ec244b1367d54 = (arg)=>typeof arg === "string";
const $079873fc3f2b5f81$export$7e4aa119212bc614 = (arg)=>typeof arg === "number";
const $079873fc3f2b5f81$export$f6e2535fb5126e54 = (arg)=>typeof arg === "function";
const $079873fc3f2b5f81$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $079873fc3f2b5f81$export$630801d484da15df = (arg)=>arg === null;
const $079873fc3f2b5f81$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $079873fc3f2b5f81$export$871608497c498473 = (d)=>d instanceof Date;
const $079873fc3f2b5f81$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === "object";
};
const $079873fc3f2b5f81$export$4e62c701997796c1 = (arg)=>{
    return $079873fc3f2b5f81$export$a6cdc56e425d0d0a(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$844ec244b1367d54(arg) || $079873fc3f2b5f81$export$7e4aa119212bc614(arg) || $079873fc3f2b5f81$export$f6e2535fb5126e54(arg) || $079873fc3f2b5f81$export$43bee75e5e14138e(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$f9ce7b637dfbe238(arg) || $079873fc3f2b5f81$export$871608497c498473(arg) || $079873fc3f2b5f81$export$630801d484da15df(arg);
};
const $079873fc3f2b5f81$export$fce6876652108ab = (arg)=>{
    return arg === undefined;
};
const $079873fc3f2b5f81$export$426db7a6155b7a80 = {
    boolean: $079873fc3f2b5f81$export$f9ce7b637dfbe238,
    array: $079873fc3f2b5f81$export$43bee75e5e14138e,
    object: $079873fc3f2b5f81$export$a6cdc56e425d0d0a,
    string: $079873fc3f2b5f81$export$844ec244b1367d54,
    date: $079873fc3f2b5f81$export$871608497c498473,
    number: $079873fc3f2b5f81$export$7e4aa119212bc614,
    null: $079873fc3f2b5f81$export$630801d484da15df,
    function: $079873fc3f2b5f81$export$f6e2535fb5126e54,
    objectLike: $079873fc3f2b5f81$export$c10d0b04eaa80a43,
    node: (0, $95800a96be489797$export$8ee0fc9ee280b4ee),
    htmlElement: (0, $95800a96be489797$export$211442cb55fb93),
    defined: $079873fc3f2b5f81$export$4e62c701997796c1
};
const $079873fc3f2b5f81$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length > 0;
    };
};
const $079873fc3f2b5f81$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length === 0;
    };
};






"use strict";
const $d0530a7c3063b815$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $d0530a7c3063b815$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(index)) index = parseInt(index);
    if ((0, $079873fc3f2b5f81$export$7e4aa119212bc614)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error("Invalid index");
        arr.splice(index, 1);
    } else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(index)) index.forEach((idx)=>$d0530a7c3063b815$export$8af121ae7401c4(arr, idx));
    else throw new Error("Invalid index");
    return arr;
};
const $d0530a7c3063b815$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $d0530a7c3063b815$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $d0530a7c3063b815$export$fd2fbaf2367ef824 = (arr, excludeFrom = [])=>{
    return arr.reduce((a, c)=>(0, $6348a97baa20d8d9$export$6969335ea1e4e77c)(a, (0, $6348a97baa20d8d9$export$b7d58db314e0ac27)(c, excludeFrom), excludeFrom), {});
};
const $d0530a7c3063b815$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj) ? $d0530a7c3063b815$export$fd2fbaf2367ef824(obj) : (0, $6348a97baa20d8d9$export$b7d58db314e0ac27)(obj);
};
const $d0530a7c3063b815$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $d0530a7c3063b815$export$e9b4b966d876219d = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $d0530a7c3063b815$export$a9706fb8026b394a = (arr, lastValue)=>{
    const nestedObject = {};
    if (arr.length === 0) return lastValue;
    arr.reduce((obj, value, index)=>{
        if (!obj[value]) obj[value] = {};
        if (index === arr.length - 1 && lastValue) obj[value] = lastValue;
        return obj[value];
    }, nestedObject);
    return nestedObject;
};
const $d0530a7c3063b815$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr.slice();
};
const $d0530a7c3063b815$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};


"use strict";
const $4537bba2bd33729a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $4537bba2bd33729a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join("\\")}]`, "g");
    // Replace matched symbols with an empty string
    return str.replace(pattern, "");
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $4537bba2bd33729a$var$brackRegex = /\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}/g;
const $4537bba2bd33729a$export$7cb52b7decbd2220 = (str, state)=>{
    if (!str.includes("{{")) return str;
    return str.replace($4537bba2bd33729a$var$brackRegex, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = parentPath.match(/\.\.\//g).length;
            let parentState = state;
            for(let i = 0; i < parentLevels; i++){
                parentState = parentState.parent;
                if (!parentState) return "" // Return an empty string if the parent level doesn't exist
                ;
            }
            const value = parentState[variable.trim()];
            return value !== undefined ? `${value}` : "";
        } else {
            const value = state[variable.trim()];
            return value !== undefined ? `${value}` : "";
        }
    });
};


"use strict";
const $6348a97baa20d8d9$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(param)) return param(element, state || element.state, context || element.context);
    return param;
};
const $6348a97baa20d8d9$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $6348a97baa20d8d9$export$78e3044358792147(extention[e], element);
};
const $6348a97baa20d8d9$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === undefined) element[e] = objProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$6969335ea1e4e77c = (element, extend, excludeFrom = [])=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(elementProp) && (0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(extendProp)) $6348a97baa20d8d9$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const o = {};
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $6348a97baa20d8d9$export$99e9e507e655127d = (obj, excludeFrom = [])=>{
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj)) return obj.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
    const o = {};
    for(const k in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, k);
        if (!hasOwnProperty || excludeFrom.includes(k) || k.startsWith("__")) continue;
        let v = obj[k];
        if (k === "extend" && (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(v)) v = $6348a97baa20d8d9$export$1c8d6f44648a0c27(v, excludeFrom);
        if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(v)) o[k] = v.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
        else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(v)) o[k] = $6348a97baa20d8d9$export$99e9e507e655127d(v, excludeFrom);
        else o[k] = v;
    }
    return o;
};
const $6348a97baa20d8d9$export$1c8d6f44648a0c27 = (arr, excl = [])=>{
    return arr.reduce((acc, curr)=>$6348a97baa20d8d9$export$6969335ea1e4e77c(acc, $6348a97baa20d8d9$export$99e9e507e655127d(curr, excl)), {});
};
const $6348a97baa20d8d9$export$b7d58db314e0ac27 = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        let objProp = obj[prop];
        if (cleanUndefined && (0, $079873fc3f2b5f81$export$fce6876652108ab)(objProp)) continue;
        if (prop === "extend" && (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) objProp = (0, $d0530a7c3063b815$export$fd2fbaf2367ef824)(objProp);
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(objProp)) o[prop] = $6348a97baa20d8d9$export$b7d58db314e0ac27(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$e249d5701977b61b = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        const objProp = obj[prop];
        if (cleanUndefined && (0, $079873fc3f2b5f81$export$fce6876652108ab)(objProp)) continue;
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(objProp)) o[prop] = $6348a97baa20d8d9$export$e249d5701977b61b(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$7885cbf849c4488d = (obj, stringified = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, stringified[prop]);
        } else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(v)) {
                    stringified[prop][i] = {};
                    $6348a97baa20d8d9$export$7885cbf849c4488d(v, stringified[prop][i]);
                } else if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$export$830c053460e5ddf6 = (obj, indent = 0)=>{
    const spaces = "  ".repeat(indent);
    let str = "{\n";
    for (const [key, value] of Object.entries(obj)){
        const keyNotAllowdChars = (0, $4537bba2bd33729a$export$5e62532c096c05e0)(key, [
            "&",
            "*",
            "-",
            ":",
            "@",
            ".",
            "/",
            "!",
            " "
        ]);
        const stringedKey = keyNotAllowdChars ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(value)) {
            str += "[\n";
            for (const element of value){
                if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(element) && element !== null) str += `${spaces}    ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(value)) str += $6348a97baa20d8d9$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(value)) str += (0, $4537bba2bd33729a$export$5e62532c096c05e0)(value, [
            "\n",
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ",\n";
    }
    str += `${spaces}}`;
    return str;
};
const $6348a97baa20d8d9$export$43ffbb9d42fee1c4 = (obj, detached = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(objProp)) continue;
        else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(objProp)) {
            detached[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, detached[prop]);
        } else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) {
            detached[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(v)) return;
                if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(v)) {
                    detached[prop][i] = {};
                    $6348a97baa20d8d9$export$43ffbb9d42fee1c4(v, detached[prop][i]);
                } else detached[prop][i] = v;
            });
        } else detached[prop] = objProp;
    }
    return detached;
};
const $6348a97baa20d8d9$export$87659e1dc59ed8a3 = (obj, destringified = {})=>{
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty) continue;
        const objProp = obj[prop];
        if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(objProp)) {
            if (objProp.includes("=>") || objProp.includes("function") || objProp.startsWith("(")) try {
                const evalProp = (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).eval(`(${objProp})`) // use parentheses to convert string to function expression
                ;
                destringified[prop] = evalProp;
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) {
            destringified[prop] = [];
            objProp.forEach((arrProp)=>{
                if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(arrProp)) {
                    if (arrProp.includes("=>") || arrProp.includes("function") || arrProp.startsWith("(")) try {
                        const evalProp = (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).eval(`(${arrProp})`) // use parentheses to convert string to function expression
                        ;
                        destringified[prop].push(evalProp);
                    } catch (e) {
                        if (e) destringified[prop].push(arrProp);
                    }
                    else destringified[prop].push(arrProp);
                } else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(arrProp)) destringified[prop].push($6348a97baa20d8d9$export$87659e1dc59ed8a3(arrProp));
                else destringified[prop].push(arrProp);
            });
        } else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(objProp)) destringified[prop] = $6348a97baa20d8d9$export$87659e1dc59ed8a3(objProp, destringified[prop]) // recursively call deepDestringify for nested objects
        ;
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $6348a97baa20d8d9$export$a6c9a3ccba61521e = (str, verbose)=>{
    try {
        return (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).eval("(" + str + ")") // eslint-disable-line
        ;
    } catch (e) {
        if (verbose) console.warn(e);
    }
};
const $6348a97baa20d8d9$export$fcd7b39b3d1c2c1 = (original, objToDiff, cache)=>{
    for(const e in objToDiff){
        if (e === "ref") continue;
        const originalProp = original[e];
        const objToDiffProp = objToDiff[e];
        if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(originalProp) && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(objToDiffProp)) {
            cache[e] = {};
            $6348a97baa20d8d9$export$a37e3c603d7117e5(originalProp, objToDiffProp, cache[e]);
        } else if (objToDiffProp !== undefined) cache[e] = objToDiffProp;
    }
    return cache;
};
const $6348a97baa20d8d9$export$f1c08b3bfc8443c4 = (original, objToDiff, cache)=>{
    if (original.length !== objToDiff.length) cache = objToDiff;
    else {
        const diffArr = [];
        for(let i = 0; i < original.length; i++){
            const diffObj = $6348a97baa20d8d9$export$a37e3c603d7117e5(original[i], objToDiff[i]);
            if (Object.keys(diffObj).length > 0) diffArr.push(diffObj);
        }
        if (diffArr.length > 0) cache = diffArr;
    }
    return cache;
};
const $6348a97baa20d8d9$export$a37e3c603d7117e5 = (original, objToDiff, cache = {})=>{
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(original) && (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objToDiff)) {
        cache = [];
        $6348a97baa20d8d9$export$f1c08b3bfc8443c4(original, objToDiff, cache);
    } else $6348a97baa20d8d9$export$fcd7b39b3d1c2c1(original, objToDiff, cache);
    return cache;
};
const $6348a97baa20d8d9$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $6348a97baa20d8d9$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $6348a97baa20d8d9$export$83b788b1a3698c03 = (o)=>(0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(o) && $6348a97baa20d8d9$export$dd1bc94b04021eeb(o);
const $6348a97baa20d8d9$export$d6d64087a1bd2d = ()=>Object.create(null);
const $6348a97baa20d8d9$export$f00d38dfe38936c3 = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(lhs) || !(0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(rhs)) return rhs;
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(rhs, key)) acc[key] = undefined;
        return acc;
    }, $6348a97baa20d8d9$export$d6d64087a1bd2d());
    if ((0, $079873fc3f2b5f81$export$871608497c498473)(lhs) || (0, $079873fc3f2b5f81$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() === rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(lhs, key)) {
            acc[key] = rhs[key];
            return acc;
        }
        const difference = $6348a97baa20d8d9$export$a37e3c603d7117e5(lhs[key], rhs[key]);
        if ($6348a97baa20d8d9$export$83b788b1a3698c03(difference) && !(0, $079873fc3f2b5f81$export$871608497c498473)(difference) && ($6348a97baa20d8d9$export$83b788b1a3698c03(lhs[key]) || !$6348a97baa20d8d9$export$83b788b1a3698c03(rhs[key]))) return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
};
const $6348a97baa20d8d9$export$d3305692eb3e9a81 = (element, params, excludeFrom = [])=>{
    const { ref: ref } = element;
    const changes = {};
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp) {
            ref.__cache[e] = changes[e] = elementProp;
            ref[e] = paramsProp;
        }
    }
    return changes;
};
const $6348a97baa20d8d9$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $6348a97baa20d8d9$export$f0b277b530b4fffd = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (e === "__proto__") continue;
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(objProp) && (0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(paramsProp)) $6348a97baa20d8d9$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $6348a97baa20d8d9$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(a) && (0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(b)) return $6348a97baa20d8d9$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $6348a97baa20d8d9$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = (0, $d0530a7c3063b815$export$803a4c6bdde5cd1d)(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $6348a97baa20d8d9$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};
const $6348a97baa20d8d9$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    // Check if both values are non-null objects
    if (typeof param !== "object" || typeof element !== "object" || param === null || element === null) return param === element // Compare non-object values directly
    ;
    // Check for circular references
    if (visited.has(param) || visited.has(element)) return true // Assume equality to break the circular reference
    ;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    // Check if both objects have the same number of properties
    if (keysParam.length !== keysElement.length) return false;
    // Check if all properties in param also exist in element
    for (const key of keysParam){
        if (!keysElement.includes(key)) return false;
        const paramProp = param[key];
        const elementProp = element[key];
        // Recursively check property values
        if (!$6348a97baa20d8d9$export$683c7d6569f339f4(paramProp, elementProp, visited)) return false;
    }
    return true;
};
const $6348a97baa20d8d9$export$273cb3019e2f952c = (obj1, obj2)=>{
    if (typeof obj1 !== typeof obj2) return false;
    if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(obj1)) {
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            for(let i = 0; i < obj1.length; i++){
                if (!$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[i], obj2[i])) return false;
            }
        } else if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(obj1) && obj2 !== null) for(const key in obj1){
            const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj2, key);
            if (!hasOwnProperty || !$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[key], obj2[key])) return false;
        }
    } else return obj2 === obj1;
    return true;
};
const $6348a97baa20d8d9$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(props)("string", "number")) delete obj[props];
    else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(props)) props.forEach((prop)=>delete obj[prop]);
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return obj;
};


"use strict";
function $b7c9275e9e0262d0$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $b7c9275e9e0262d0$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $b7c9275e9e0262d0$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $b7c9275e9e0262d0$export$6f017d9966fe4675 = (inputString)=>{
    // Regular expression to match both regular and arrow function declarations
    const functionRegex = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
    // Use the regex to test if the inputString matches the function pattern
    return functionRegex.test(inputString);
};




"use strict";
const $958f2e9ae228360b$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $958f2e9ae228360b$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};





"use strict";
const $3bae52d896fdaae9$export$d0a8044dce8ff2fc = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
const $3bae52d896fdaae9$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(document) || (0, $079873fc3f2b5f81$export$fce6876652108ab)(document.cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $3bae52d896fdaae9$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(document) || (0, $079873fc3f2b5f81$export$fce6876652108ab)(document.cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
};


"use strict";
const $be778da0f6744ca3$export$4c3fa92ca590c71f = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};
const $be778da0f6744ca3$export$52675ca41d41c093 = (arg)=>$be778da0f6744ca3$export$4c3fa92ca590c71f.body.includes(arg);


"use strict";


"use strict";
const $06908963bda72849$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: "Document is undefined",
            description: "To tweak with DOM, you should use browser."
        },
        OverwriteToBuiltin: {
            title: "Overwriting to builtin method",
            description: "Overwriting a builtin method in the window define is not possible, please choose different name"
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: "Environment should be browser application, that can run Javascript"
        },
        SetQuickPreferancesIsNotObject: {
            title: "Quick preferances object is required",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: "Params are invalid",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: "You must provide node",
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: "Element tag name (or DOM nodeName) is invalid",
            description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
        },
        HTMLInvalidAttr: {
            title: "Attibutes object is invalid",
            description: "Please pass a valid plain object to apply as an attributes for a DOM node"
        },
        HTMLInvalidData: {
            title: "Data object is invalid",
            description: "Please pass a valid plain object to apply as an dataset for a DOM node"
        },
        HTMLInvalidStyles: {
            title: "Styles object is invalid",
            description: "Please pass a valid plain object to apply as an style for a DOM node"
        },
        HTMLInvalidText: {
            title: "Text string is invalid",
            description: "Please pass a valid string to apply text to DOM node"
        },
        ElementOnStateIsNotDefined: {
            title: "Element on state is not defined",
            description: "Please check the element object"
        }
    }
};
const $06908963bda72849$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = "en";
    let errObj;
    if (err && typeof err === "string") errObj = $06908963bda72849$export$fc4da02de2c0bd43[currentLang][err];
    return new Error(`"${err}", "${arg}"\n\n`, `${errObj.description}`, element ? `\n\n${element}` : "");
};


"use strict";
const $80563b8eaf6ba844$export$fbea82a1c0574ef4 = {
    key: ":root",
    node: (0, $e33f3b456b841cc9$export$5a7bfc01df82fcd1) ? (0, $e33f3b456b841cc9$export$5a7bfc01df82fcd1).body : (0, $06908963bda72849$export$f18d5b0af29128b7)("DocumentNotDefined", (0, $e33f3b456b841cc9$export$5a7bfc01df82fcd1))
};
const $80563b8eaf6ba844$export$33ecaa422889cd80 = $80563b8eaf6ba844$export$fbea82a1c0574ef4;




"use strict";
const $33936e69aa63c9cd$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    return param(element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$1bc010482b845252 = (param, element, options)=>{
    if (element.on && (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$27ca81ea148fa005(element.on[param], element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    return param(updatedObj, element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    if (element.on && (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$906113ec468a9c43(element.on[param], updatedObj, element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on } = element;
    for(const param in on){
        if (param === "init" || param === "beforeClassAssign" || param === "render" || param === "renderRouter" || param === "attachNode" || param === "stateInit" || param === "stateCreated" || param === "initStateUpdated" || param === "stateUpdated" || param === "initUpdate" || param === "update") continue;
        const appliedFunction = element.on[param];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(appliedFunction)) node.addEventListener(param, (event)=>{
            const { state: state, context: context } = element;
            appliedFunction(event, element, state, context, options);
        });
    }
};




"use strict";
const $a7c2803c7e7b293f$export$5d42fc0d80b5349f = (element)=>{
    const tag = element.tag || "div";
    return (0, $be778da0f6744ca3$export$52675ca41d41c093)(tag) || (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag");
};


"use strict";


"use strict";
const $8af08dc9e7559b54$export$270e7ba5936d3c48 = (element)=>{};





"use strict";
const $01ef634a92434650$var$cache = {};
const $01ef634a92434650$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag } = element;
    if (tag) {
        if (tag === "string") return document.createTextNode(element.text);
        else if (tag === "fragment") return document.createDocumentFragment();
        else if (tag === "svg" || tag === "path") return document.createElementNS("http://www.w3.org/2000/svg", tag);
        else return document.createElement(tag) // TODO: allow strict mode to check validity
        ;
    } else return document.createElement("div");
};
const $01ef634a92434650$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $6348a97baa20d8d9$export$78e3044358792147)(tag, element);
    if (tag === true) tag = key;
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(props) && (0, $079873fc3f2b5f81$export$844ec244b1367d54)(props.tag)) {
        const tagExists = (0, $be778da0f6744ca3$export$52675ca41d41c093)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(tag)) {
        const tagExists = (0, $be778da0f6744ca3$export$52675ca41d41c093)(tag);
        if (tagExists) return tag;
    } else {
        const isKeyATag = (0, $be778da0f6744ca3$export$52675ca41d41c093)(key);
        if (isKeyATag) return key;
    }
    return "div";
};
const $01ef634a92434650$export$257247f9c0329159 = (element)=>{
    const tag = element.tag = $01ef634a92434650$export$5075bd4eae016d2c(element);
    if (!(0, $a7c2803c7e7b293f$export$5d42fc0d80b5349f)(element)) return (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag", element.tag, element);
    let cachedTag = $01ef634a92434650$var$cache[tag];
    if (!cachedTag) cachedTag = $01ef634a92434650$var$cache[tag] = $01ef634a92434650$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === "string") clonedNode.nodeValue = element.text;
    return clonedNode;
};


"use strict";
const $98807bf18bc93fb3$export$13970129ca912f06 = (node, parentNode)=>{
    parentNode.appendChild(node);
    return node;
};
const $98807bf18bc93fb3$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    if (siblingNode.nextSibling) parent?.insertBefore(node, siblingNode.nextSibling);
    else siblingNode?.insertAdjacentElement("afterend", node);
};
const $98807bf18bc93fb3$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    (parentNode || siblingNode.parentNode)?.insertBefore(node, siblingNode);
};
const $98807bf18bc93fb3$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    parent[key || element.key] = element;
    if (element.tag !== "shadow") {
        if (attachOptions && attachOptions.position) (attachOptions.position === "before" ? $98807bf18bc93fb3$export$3a727f1d0007fe49 : $98807bf18bc93fb3$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $98807bf18bc93fb3$export$13970129ca912f06(element.node, parent.node);
    }
    return element;
};


"use strict";






"use strict";
var /**
 * Recursively add attributes to a DOM node
 */ $781ba30c522cf3e7$export$2e2bcd8739ae039 = (params, element, node)=>{
    const { __ref: __ref } = element;
    const { __attr: __attr } = __ref;
    if ((0, $079873fc3f2b5f81$export$612ae635ef713eeb)("object")) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidAttr", params);
    if (params) for(const attr in params){
        const val = (0, $6348a97baa20d8d9$export$78e3044358792147)(params[attr], element);
        // if (__attr[attr] === val) return
        if (val && node.setAttribute) node.setAttribute(attr, val);
        else if (node.removeAttribute) node.removeAttribute(attr);
        __attr[attr] = val;
    }
    console.groupEnd(params, __attr);
};



"use strict";
const $6a43953e96d89b45$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
};
const $6a43953e96d89b45$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $6348a97baa20d8d9$export$78e3044358792147)(param, element)}`;
    }
    return className;
};
const $6a43953e96d89b45$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(params)) params = element.class = {
        default: params
    };
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(params)) params = $6a43953e96d89b45$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, " ").trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $6a43953e96d89b45$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $6a43953e96d89b45$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
var $6a43953e96d89b45$export$2e2bcd8739ae039 = (params, element, node)=>{
    $6a43953e96d89b45$export$e8f750c9f10c0a7b(params, element, node);
};





"use strict";
var $ad3d3b247d47f3a2$export$2e2bcd8739ae039 = {};




"use strict";
const $bf937aebc888d68f$var$set = function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref, content: content } = element;
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    if (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && (0, $6348a97baa20d8d9$export$273cb3019e2f952c)(params, content)) return content.update();
    if (options.preventContentUpdate === true) return;
    const setAsync = ()=>{
        (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def)(element);
        (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(params, element, "content", {
            ignoreChildExtend: true,
            ...(0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions,
            ...(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create,
            ...options
        });
    };
    if (params) {
        const { childExtend: childExtend } = params;
        if (!childExtend && element.childExtend) params.childExtend = element.childExtend;
        if (lazyLoad) window.requestAnimationFrame(setAsync);
        else setAsync();
    }
    return element;
};
var $bf937aebc888d68f$export$2e2bcd8739ae039 = $bf937aebc888d68f$var$set;


"use strict";
const $0a7669919424e35c$export$5143cc956eb9d8f6 = function(params, options) {
    const element = this;
    if (!element.content) return;
    if (element.content.update) element.content.update(params, options);
};
const $0a7669919424e35c$export$6e1d9b0d0e1e1def = function(el) {
    const element = el || this;
    const { __ref: __ref } = element;
    if (element.content) {
        if (element.content.node) {
            if (element.content.tag === "fragment") element.node.innerHTML = "";
            else element.node.removeChild(element.content.node);
        }
        const { __cached: __cached } = __ref;
        if (__cached && __cached.content) {
            if (__cached.content.tag === "fragment") __cached.content.parent.node.innerHTML = "";
            else if (__cached.content && (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(__cached.content.remove)) __cached.content.remove();
        }
        delete element.content;
    }
};
const $0a7669919424e35c$export$431313f2afd011e2 = (param, element, node, options)=>{
    if (param && element) {
        if (element.content.update) element.content.update({}, options);
        else (0, $bf937aebc888d68f$export$2e2bcd8739ae039).call(element, param, options);
    }
};
var $0a7669919424e35c$export$2e2bcd8739ae039 = $0a7669919424e35c$export$431313f2afd011e2;




"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $e4aeb17327021212$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params && params.showOnNode) {
        if (!(0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(params)) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidData", params);
        // Apply data params on node
        for(const dataset in params)if (dataset !== "showOnNode") node.dataset[dataset] = (0, $6348a97baa20d8d9$export$78e3044358792147)(params[dataset], element);
    }
};



"use strict";
var /**
 * Appends raw HTML as content
 * an original one as a child
 */ $1591488d379f80a7$export$2e2bcd8739ae039 = (param, element, node)=>{
    const prop = (0, $6348a97baa20d8d9$export$78e3044358792147)(param, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        // const parser = new window.DOMParser()
        // param = parser.parseFromString(param, 'text/html')
        if (node.nodeName === "SVG") node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
};




"use strict";
var /**
 * Recursively add styles to a DOM node
 */ $479abf9e8c0e6739$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params) {
        if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(params)) (0, $6348a97baa20d8d9$export$871de8747c9eaa88)(node.style, params, element);
        else (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidStyles", params);
    }
};




"use strict";
var /**
 * Creates a text node and appends into
 * an original one as a child
 */ $19f4b3c5f241581d$export$2e2bcd8739ae039 = (param, element, node)=>{
    let prop = (0, $6348a97baa20d8d9$export$78e3044358792147)(param, element);
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(prop) && prop.includes("{{")) prop = (0, $4537bba2bd33729a$export$7cb52b7decbd2220)(prop, element.state);
    if (element.tag === "string") node.nodeValue = prop;
    else if (param !== undefined || param !== null) {
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $947d5c063e68e91c$export$2e2bcd8739ae039)({
            tag: "string",
            text: prop
        }, element, "__text");
    }
};


"use strict";
const $bfb47641e396194b$export$5100524046ce8de6 = [
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "__root"
];







"use strict";
const $7c314a91da5c12c3$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) obj[param] = state[param];
        return obj;
    } else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(state)) return state.filter((item)=>!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(item));
};
const $7c314a91da5c12c3$export$cf0b2a6c63f9e656 = function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) delete state[param];
    if (!options.preventStateUpdate) state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $7c314a91da5c12c3$export$b1fb4cac938035f7 = function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(stateKey)) {
        element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(child.state)) Object.defineProperty(child.state, "parent", {
                value: state.parent,
                enumerable: false,
                configurable: true,
                writable: true // Set this to true if you want to allow changing the function later
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $7c314a91da5c12c3$export$e45af8832c6abf26 = function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$c2f300c8c094e900 = function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.__root.state;
    return rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $7c314a91da5c12c3$export$e16d8520af44a096 = function(value, options = {}) {
    const state = this;
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(state)) {
        state.push(value);
        state.update(state.parse(), {
            overwrite: "replace",
            ...options
        });
    } else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(state)) {
        const key = Object.keys(state).length;
        state.update({
            [key]: value
        }, options);
    }
};
const $7c314a91da5c12c3$export$e03c1c3201ee8bb7 = function(key, options = {}) {
    const state = this;
    state.update({
        [key]: !state[key]
    }, options);
};
const $7c314a91da5c12c3$export$cd7f480d6b8286c3 = function(key, options = {}) {
    const state = this;
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(state)) (0, $d0530a7c3063b815$export$8af121ae7401c4)(state, key);
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(state)) (0, $6348a97baa20d8d9$export$bdd7fc6cf95d63b)(state, key);
    return state.update(state.parse(), {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$adaa4cf7ef1b65be = function(val, options = {}) {
    const state = this;
    const value = (0, $6348a97baa20d8d9$export$e249d5701977b61b)(val);
    return state.clean({
        preventStateUpdate: true,
        ...options
    }).update(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$aad8462122ac592b = function(options = {}) {
    const state = this;
    const value = (0, $6348a97baa20d8d9$export$e249d5701977b61b)(state.parse());
    return state.set(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$5635d7ef4b8fee1c = function(func, options = {}) {
    const state = this;
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(func)) {
        func(state);
        return state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};








"use strict";
const $5fcb062e9eb35754$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes("../")) return;
    const arr = stateKey.split("../");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $5fcb062e9eb35754$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = stateKey.split("/");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === "__proto__" || grandChildKey === "__proto__") return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $5fcb062e9eb35754$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$5fcb062e9eb35754$export$e187d7e20e9fd8fa(element)) return;
    let parentState = parent.state;
    const findGrandParentState = $5fcb062e9eb35754$export$f7dd4f6f6830b29d(stateKey, parent.state);
    if (findGrandParentState) {
        parentState = findGrandParentState;
        stateKey = stateKey.replaceAll("../", "");
    }
    if (!parentState) return;
    return $5fcb062e9eb35754$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $5fcb062e9eb35754$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $5fcb062e9eb35754$export$487549069bb5d2a9(element, parent);
    if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(inheritedState)) return element.state;
    if ((0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(inheritedState)("object", "array")) return (0, $6348a97baa20d8d9$export$e249d5701977b61b)(inheritedState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    else if ((0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(inheritedState)("string", "number", "boolean")) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, "is not present. Replacing with", {});
};
const $5fcb062e9eb35754$export$e187d7e20e9fd8fa = (element)=>{
    const ref = element.__ref;
    const stateKey = ref.__state;
    if (stateKey && (0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(stateKey)("number", "string", "boolean")) return true;
    return false;
};
const $5fcb062e9eb35754$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(state)) return false;
    return state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.toggle && state.add && state.apply && state.__element && state.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
};
const $5fcb062e9eb35754$export$2318606fe59d6594 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split("/");
    const obj = {};
    let ref = obj;
    keys.forEach((key, index)=>{
        ref[key] = index === keys.length - 1 ? value || {} : {};
        ref = ref[key];
    });
    return obj;
};


"use strict";
const $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true,
    execStateFunction: true
};
const $8b576c5d9c1d0c84$export$4971331372cec95a = function(obj, options = $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (!options.updateByState) (0, $6348a97baa20d8d9$export$4950aa0f605343fb)(options, $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $06908963bda72849$export$f18d5b0af29128b7)("ElementOnStateIsNotDefined");
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventInitStateUpdateListener) {
        const initStateUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdated", obj, element, options);
        if (initStateUpdateReturns === false) return element;
    }
    $8b576c5d9c1d0c84$var$applyOverwrite(state, obj, options);
    const updateIsHoisted = $8b576c5d9c1d0c84$var$hoistStateUpdate(state, obj, options);
    if (updateIsHoisted) return state;
    $8b576c5d9c1d0c84$var$updateDependentState(state, obj, options);
    $8b576c5d9c1d0c84$var$applyElementUpdate(state, obj, options);
    if (!options.preventStateUpdateListener) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdated", obj, element, options);
    return state;
};
const $8b576c5d9c1d0c84$var$applyOverwrite = (state, obj, options)=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === "shallow";
    const merge = overwrite === "merge";
    if (merge) {
        (0, $6348a97baa20d8d9$export$6969335ea1e4e77c)(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
        return;
    }
    const overwriteFunc = shallow ? (0, $6348a97baa20d8d9$export$1c07155dfdd98f41) : (0, $6348a97baa20d8d9$export$f0b277b530b4fffd);
    overwriteFunc(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
};
const $8b576c5d9c1d0c84$var$hoistStateUpdate = (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref.__state;
    const stateType = ref.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element);
    const inheritedState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === "string" || stateType === "number" || stateType === "boolean";
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findGrandParentState = (0, $5fcb062e9eb35754$export$f7dd4f6f6830b29d)(stateKey, parent.state);
    const changesValue = (0, $5fcb062e9eb35754$export$2318606fe59d6594)(stateKey, passedValue);
    const targetParent = findGrandParentState || parent.state;
    if (options.replace) (0, $6348a97baa20d8d9$export$f0b277b530b4fffd)(targetParent, changesValue || value) // check with createChangesByKey
    ;
    targetParent.update(changesValue, {
        execStateFunction: false,
        isHoisted: true,
        ...options,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdated", obj, element, options);
    return true;
};
const $8b576c5d9c1d0c84$var$updateDependentState = (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        dependentState.clean().update(state.parse(), options);
    }
};
const $8b576c5d9c1d0c84$var$applyElementUpdate = (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === "recursive") element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};



"use strict";
const $774f1a3b2fe82710$export$e6a0daad8304de = function(element, parent, options) {
    element.state = $774f1a3b2fe82710$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $774f1a3b2fe82710$export$6e8a0938c76079c7 = function(element, parent, options) {
    const objectizeState = $774f1a3b2fe82710$var$checkForTypes(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = (0, $6348a97baa20d8d9$export$e249d5701977b61b)(objectizeState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const whatInitReturns = (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateInit", element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element)) {
        const inheritedState = (0, $5fcb062e9eb35754$export$c546cc738d4564ba)(element, parent);
        element.state = (0, $079873fc3f2b5f81$export$fce6876652108ab)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = $774f1a3b2fe82710$var$applyDependentState(element, element.state);
    if (dependentState) element.state = dependentState;
    $774f1a3b2fe82710$var$applyMethods(element);
    // trigger `on.stateCreated`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateCreated", element);
    return element.state;
};
const $774f1a3b2fe82710$var$applyDependentState = (element, state)=>{
    const { __ref: ref } = state;
    if (!ref) return;
    const dependentState = (0, $6348a97baa20d8d9$export$e249d5701977b61b)(ref, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const newDepends = {
        [element.key]: dependentState
    };
    ref.__depends = (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(ref.__depends) ? {
        ...ref.__depends,
        ...newDepends
    } : newDepends;
    return dependentState;
};
const $774f1a3b2fe82710$var$checkForTypes = (element)=>{
    const { state: state, __ref: ref } = element;
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(state)) {
        ref.__state = state;
        return (0, $6348a97baa20d8d9$export$78e3044358792147)(state, element);
    } else if ((0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(state)("string", "number")) {
        ref.__state = state;
        return {};
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $774f1a3b2fe82710$var$addProtoToArray = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};
const $774f1a3b2fe82710$var$applyMethods = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: (0, $7c314a91da5c12c3$export$cf0b2a6c63f9e656).bind(state),
        parse: (0, $7c314a91da5c12c3$export$98e6a39c04603d36).bind(state),
        destroy: (0, $7c314a91da5c12c3$export$b1fb4cac938035f7).bind(state),
        update: (0, $8b576c5d9c1d0c84$export$4971331372cec95a).bind(state),
        rootUpdate: (0, $7c314a91da5c12c3$export$c2f300c8c094e900).bind(state),
        parentUpdate: (0, $7c314a91da5c12c3$export$e45af8832c6abf26).bind(state),
        create: $774f1a3b2fe82710$export$e6a0daad8304de.bind(state),
        add: (0, $7c314a91da5c12c3$export$e16d8520af44a096).bind(state),
        toggle: (0, $7c314a91da5c12c3$export$e03c1c3201ee8bb7).bind(state),
        remove: (0, $7c314a91da5c12c3$export$cd7f480d6b8286c3).bind(state),
        apply: (0, $7c314a91da5c12c3$export$5635d7ef4b8fee1c).bind(state),
        set: (0, $7c314a91da5c12c3$export$adaa4cf7ef1b65be).bind(state),
        reset: (0, $7c314a91da5c12c3$export$aad8462122ac592b).bind(state),
        parent: element.parent.state,
        __element: element,
        __children: {},
        __root: ref.__root ? ref.__root.state : state
    };
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(state)) $774f1a3b2fe82710$var$addProtoToArray(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};





"use strict";



"use strict";
const $4a610b4ab9f6f506$export$ca000e230c0caa3e = (params, element, node)=>{
    const state = (0, $6348a97baa20d8d9$export$78e3044358792147)(params, element);
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(state)) for(const param in state){
        if ((0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) continue;
        if (!Object.hasOwnProperty.call(state, param)) continue;
        element.state[param] = (0, $6348a97baa20d8d9$export$78e3044358792147)(state[param], element);
    }
    return element;
};
var $4a610b4ab9f6f506$export$2e2bcd8739ae039 = $4a610b4ab9f6f506$export$ca000e230c0caa3e;



"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $d1bc0a58271a837c$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (!(0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
};



"use strict";
var $782cf63e523d0885$export$2e2bcd8739ae039 = {
    attr: $781ba30c522cf3e7$export$2e2bcd8739ae039,
    style: $479abf9e8c0e6739$export$2e2bcd8739ae039,
    text: $19f4b3c5f241581d$export$2e2bcd8739ae039,
    html: $1591488d379f80a7$export$2e2bcd8739ae039,
    content: $0a7669919424e35c$export$2e2bcd8739ae039,
    data: $e4aeb17327021212$export$2e2bcd8739ae039,
    class: (0, $6a43953e96d89b45$export$2e2bcd8739ae039),
    state: $4a610b4ab9f6f506$export$2e2bcd8739ae039,
    scope: $d1bc0a58271a837c$export$2e2bcd8739ae039,
    deps: (param, el)=>param || el.parent.deps,
    extend: {},
    childExtend: {},
    childExtendRecursive: {},
    props: {},
    path: {},
    if: {},
    define: {},
    transform: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    nextElement: {},
    previousElement: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    set: {},
    update: {},
    setProps: {},
    remove: {},
    updateContent: {},
    removeContent: {},
    lookup: {},
    spotByPath: {},
    keys: {},
    log: {},
    parse: {},
    parseDeep: {},
    on: {},
    component: {},
    context: {},
    $setStateCollection: {},
    $setCollection: {},
    $setPropsCollection: {}
};
const $782cf63e523d0885$export$2f387f690230eab4 = {
    elementKeys: [
        "tag",
        "text",
        "style",
        "attr",
        "class",
        "state",
        "props",
        "data",
        "content",
        "html",
        "on",
        "key"
    ],
    propsKeys: [
        "__element",
        "update"
    ],
    stateKeys: []
};


"use strict";


"use strict";
const $d61abc47c39ce5ac$export$cec27f102c074405 = function(path) {
    const element = this;
    const arr = [].concat(path);
    let active = (0, $80563b8eaf6ba844$export$33ecaa422889cd80)[arr[0]];
    if (!arr || !arr.length) return console.log(arr, "on", element.key, "is undefined");
    while(active.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        active = active[arr[0]];
        if (!active) return;
    }
    return active;
};
const $d61abc47c39ce5ac$export$dfc7155ac0343b8 = function(key) {
    const element = this;
    let { parent: parent } = element;
    while(parent.key !== key){
        if (parent[key]) return parent[key];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
};
const $d61abc47c39ce5ac$export$cd7f480d6b8286c3 = function(params) {
    const element = this;
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.node.remove)) element.node.remove();
    else if (!(0, $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4)()) {
        console.warn("This item cant be removed");
        element.log();
    }
    delete element.parent[element.key];
};
const $d61abc47c39ce5ac$export$3988ae62b71be9a3 = function(param) {
    const element = this;
    return element[param];
};
const $d61abc47c39ce5ac$export$938ca3893886de06 = function(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
};
const $d61abc47c39ce5ac$export$a98d858bb785d7b9 = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
const $d61abc47c39ce5ac$export$ed97f33186d4b816 = function() {
    const element = this;
    const keys = [];
    for(const param in element){
        if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !(0, $782cf63e523d0885$export$2f387f690230eab4).elementKeys.includes(param)) continue;
        keys.push(param);
    }
    return keys;
};
const $d61abc47c39ce5ac$export$98e6a39c04603d36 = function(excl = []) {
    const element = this;
    const obj = {};
    const keyList = $d61abc47c39ce5ac$export$ed97f33186d4b816.call(element);
    keyList.forEach((v)=>{
        if (excl.includes(v)) return;
        let val = element[v];
        if (v === "state") {
            if (element.__ref && element.__ref.__hasRootState) return;
            if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(val && val.parse)) val = val.parse();
        } else if (v === "props") {
            const { __element: __element, update: update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $079873fc3f2b5f81$export$4e62c701997796c1)(val)) obj[v] = val;
    });
    return obj;
};
const $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2 = function(excl = []) {
    const element = this;
    const obj = $d61abc47c39ce5ac$export$98e6a39c04603d36.call(element, excl);
    for(const v in obj){
        if (excl.includes(v)) return;
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(obj[v])) obj[v] = $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2.call(obj[v], excl);
    }
    return obj;
};
const $d61abc47c39ce5ac$export$bef1f36f5486a6a3 = function(...args) {
    const element = this;
    const { __ref: __ref } = element;
    console.group(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    else {
        console.log(__ref.path);
        const keys = element.keys();
        keys.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    }
    console.groupEnd(element.key);
    return element;
};
const $d61abc47c39ce5ac$export$e87a5caa96444a37 = function() {
    const element = this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
};
const $d61abc47c39ce5ac$export$1facc1d780a4d839 = function(el) {
    const element = el || this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
};
const $d61abc47c39ce5ac$export$f0748ddc99f937c7 = [
    "set",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "if",
    "log",
    "nextElement",
    "previousElement"
];
const $d61abc47c39ce5ac$export$ed2133acb96eb5aa = function(param) {
    return $d61abc47c39ce5ac$export$f0748ddc99f937c7.includes(param);
};






"use strict";
const $c6321d44fd66ade0$export$431871e52735632b = [
    "update",
    "__element"
];





"use strict";
const $045c563bb4b0b2eb$var$objectizeStringProperty = (propValue)=>{
    if ((0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(propValue)("string", "number")) return {
        inheritedString: propValue
    };
    return propValue;
};
const $045c563bb4b0b2eb$export$d25057a75c14aff7 = (element, parent)=>{
    let propsStack = [];
    const parentProps = (0, $6348a97baa20d8d9$export$78e3044358792147)(parent, parent.state).props;
    const matchParent = parent.props && parentProps[element.key];
    const matchParentIsString = (0, $079873fc3f2b5f81$export$844ec244b1367d54)(matchParent);
    const matchParentChildProps = parentProps && parentProps.childProps;
    if (matchParent) {
        if (matchParentIsString) {
            const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
            if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
            else propsStack = [].concat($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent), propsStack);
        } else propsStack.push($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent));
    }
    if (matchParentChildProps) propsStack.push(matchParentChildProps);
    return propsStack;
};


"use strict";
const $e818f1ed291a38e8$var$createPropsStack = (element, parent)=>{
    const { props: props, __ref: __ref } = element;
    const propsStack = __ref.__props = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(props)) propsStack.push(props);
    else if (props === "inherit" && parent.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(__ref.__extend)) __ref.__extend.forEach((extend)=>{
        if (extend.props && extend.props !== props) propsStack.push(extend.props);
    });
    __ref.__props = propsStack;
    return propsStack;
};
const $e818f1ed291a38e8$export$b23ca50362483f82 = (props, element)=>{
    element.props = {};
    const mergedProps = {};
    props.forEach((v)=>{
        if ((0, $c6321d44fd66ade0$export$431871e52735632b).includes(v)) return;
        const execProps = (0, $6348a97baa20d8d9$export$78e3044358792147)(v, element);
        // TODO: check if this failing the function props merge
        // if (isObject(execProps) && execProps.__element) return
        // it was causing infinite loop at early days
        element.props = (0, $6348a97baa20d8d9$export$6969335ea1e4e77c)(mergedProps, (0, $6348a97baa20d8d9$export$b7d58db314e0ac27)(execProps, (0, $c6321d44fd66ade0$export$431871e52735632b)), (0, $c6321d44fd66ade0$export$431871e52735632b));
    });
    element.props = mergedProps;
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element.props;
};
const $e818f1ed291a38e8$export$c94ea207b45fef3a = function(element, parent, cached) {
    const { __ref: ref } = element;
    // if (element.parent.key === '0' && element.key === 'editor') {
    //   debugger
    // }
    const applyProps = ()=>{
        const propsStack = cached || $e818f1ed291a38e8$var$createPropsStack(element, parent);
        if (propsStack.length) {
            ref.__props = propsStack;
            $e818f1ed291a38e8$export$b23ca50362483f82(propsStack, element);
        } else {
            ref.__props = cached || [];
            element.props = {};
        }
    };
    if (ref.__if) applyProps();
    else try {
        applyProps();
    } catch  {
        element.props = {};
        ref.__props = cached || [];
    }
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element;
};
function $e818f1ed291a38e8$var$update(props, options) {
    const element = this.__element;
    element.update({
        props: props
    }, options);
}





"use strict";
const $902e7fcbfa0a2596$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: __ref } = element;
    let propsStack = __ref.__props;
    const parentProps = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
    if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
    if (propsStack) (0, $e818f1ed291a38e8$export$b23ca50362483f82)(propsStack, element);
    return element;
};


"use strict";



"use strict";
const $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d = (0, $d0530a7c3063b815$export$fc359ae9633f7296)([
    "node",
    "state",
    "context",
    "extend"
], (0, $d61abc47c39ce5ac$export$f0748ddc99f937c7), (0, $bfb47641e396194b$export$5100524046ce8de6), (0, $c6321d44fd66ade0$export$431871e52735632b));
const $9dbe2fe74e93fc61$export$6969335ea1e4e77c = (element, extend, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in extend){
        if (exclude.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(elementProp) && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(extendProp)) $9dbe2fe74e93fc61$export$6969335ea1e4e77c(elementProp, extendProp);
    }
    return element;
};
const $9dbe2fe74e93fc61$export$9cd59f9826255e47 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        o[e] = obj[e];
    }
    return o;
};
const $9dbe2fe74e93fc61$export$b7d58db314e0ac27 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj) ? [] : {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        let objProp = obj[e];
        if (e === "extend" && (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) objProp = $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(objProp, exclude);
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(objProp)) o[e] = $9dbe2fe74e93fc61$export$b7d58db314e0ac27(objProp, exclude);
        else o[e] = objProp;
    }
    return o;
};
const $9dbe2fe74e93fc61$export$d3305692eb3e9a81 = (element, params, options)=>{
    const changes = {};
    const { __ref: __ref } = element;
    const { __exec: __exec, __cached: __cached } = __ref;
    for(const e in params){
        if (e === "props" || e === "state" || e === "__ref") continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            __cached[e] = changes[e] = elementProp;
            element[e] = paramsProp;
        }
        if (options.cleanExec) delete __exec[e];
    }
    return changes;
};
const $9dbe2fe74e93fc61$export$1c07155dfdd98f41 = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$f0b277b530b4fffd = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(objProp) && (0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(paramsProp)) $9dbe2fe74e93fc61$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(a) && (0, $079873fc3f2b5f81$export$c10d0b04eaa80a43)(b)) return $9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $9dbe2fe74e93fc61$export$fd2fbaf2367ef824 = (arr, exclude = [
    "parent",
    "node",
    "__element",
    "state",
    "context",
    "__ref"
])=>{
    return arr.reduce((a, c)=>$9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, $9dbe2fe74e93fc61$export$b7d58db314e0ac27(c, exclude)), {});
};
const $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(obj) ? $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(obj) : $9dbe2fe74e93fc61$export$b7d58db314e0ac27(obj);
};
const $9dbe2fe74e93fc61$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $9dbe2fe74e93fc61$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};



"use strict";
const $ce326eb5cdcc3ce9$var$ENV = "production";
const $ce326eb5cdcc3ce9$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d = {};
const $ce326eb5cdcc3ce9$export$bc442b6cc8c83971 = {};
const $ce326eb5cdcc3ce9$export$46ce3405574370c6 = (extend)=>{
    return $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[extend.__hash];
};
const $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $ce326eb5cdcc3ce9$export$daf4c137c5f56404();
    if (!(0, $079873fc3f2b5f81$export$844ec244b1367d54)(extend)) extend.__hash = hash;
    $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $ce326eb5cdcc3ce9$export$6ef9dd655b57622a = (extend, stack)=>{
    if (extend.__hash) return stack.concat($ce326eb5cdcc3ce9$export$46ce3405574370c6(extend));
    return $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $ce326eb5cdcc3ce9$export$2c118161a655606a = (extend, stack, context)=>{
    extend.forEach((each)=>$ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(each, stack, context));
    return stack;
};
const $ce326eb5cdcc3ce9$export$54e9fb29908872fa = (extend, stack, context)=>{
    const extendOflattenExtend = extend.extend;
    if (extendOflattenExtend) $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2 = (extend, stack, context)=>{
    if (!extend) return stack;
    if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(extend)) return $ce326eb5cdcc3ce9$export$2c118161a655606a(extend, stack, context);
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(extend)) extend = $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315(extend, context);
    stack.push(extend);
    if (extend.extend) $ce326eb5cdcc3ce9$export$54e9fb29908872fa(extend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$16fb354ab895483c = (obj)=>{
    const o = {};
    for(const prop in obj){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(prop) > -1) continue;
        const objProp = obj[prop];
        if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(objProp)) o[prop] = $ce326eb5cdcc3ce9$export$16fb354ab895483c(objProp);
        else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(objProp)) o[prop] = objProp.map((x)=>x);
        else o[prop] = objProp;
    }
    return o;
};
const $ce326eb5cdcc3ce9$export$d20ceec222df68ed = (element, extend)=>{
    for(const e in extend){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(e) > -1) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(elementProp) && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(extendProp)) $ce326eb5cdcc3ce9$export$d20ceec222df68ed(elementProp, extendProp);
        else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(elementProp) && (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(extendProp)) element[e] = elementProp.concat(extendProp);
        else if ((0, $079873fc3f2b5f81$export$43bee75e5e14138e)(elementProp) && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(extendProp)) {
            const obj = $ce326eb5cdcc3ce9$export$d20ceec222df68ed({}, elementProp);
            element[e] = $ce326eb5cdcc3ce9$export$d20ceec222df68ed(obj, extendProp);
        } else if (elementProp === undefined && (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(extendProp)) element[e] = extendProp;
    }
    return element;
};
const $ce326eb5cdcc3ce9$export$e2e460d82983fb19 = (stack)=>{
    return stack.reduce((a, c)=>{
        return $ce326eb5cdcc3ce9$export$d20ceec222df68ed(a, $ce326eb5cdcc3ce9$export$16fb354ab895483c(c));
    }, {});
};
const $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315 = (extend, context, options = {})=>{
    const COMPONENTS = context && context.components || options.components;
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(extend)) {
        const componentExists = COMPONENTS[extend] || COMPONENTS["smbls." + extend];
        if (COMPONENTS && componentExists) return componentExists;
        else {
            if ($ce326eb5cdcc3ce9$var$ENV !== "test" || $ce326eb5cdcc3ce9$var$ENV !== "development") console.warn("Extend is string but component was not found:", extend);
            return {};
        }
    }
    return extend;
};
const $ce326eb5cdcc3ce9$export$f9f936cf352c3af2 = (extendStack, childExtendStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
};
const $ce326eb5cdcc3ce9$export$a0203ee23029af7e = (extend, context)=>{
    if (!extend) return [];
    if (extend.__hash) return $ce326eb5cdcc3ce9$export$46ce3405574370c6(extend) || [];
    const stack = $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extend, [], context);
    return $ce326eb5cdcc3ce9$export$6ef9dd655b57622a(extend, stack);
};
const $ce326eb5cdcc3ce9$export$52f1fe7126b651a = (extend)=>{
    const stack = $ce326eb5cdcc3ce9$export$a0203ee23029af7e(extend);
    return $ce326eb5cdcc3ce9$export$e2e460d82983fb19(stack);
} // export const replaceStringsWithComponents = (stack, context, options) => {
 //   const COMPONENTS = (context && context.components) || options.components
 //   return stack.map(v => {
 //     if (isString(v)) {
 //       const component = COMPONENTS[v]
 //       return component
 //     }
 //     if (isString(v.extend)) {
 //       v.extend = getExtendMerged(COMPONENTS[v.extend])
 //     }
 //     return v
 //   })
 // }
;





"use strict";
const $3bff1c984b824aeb$var$ENV = "production";
const $3bff1c984b824aeb$export$f20941eae6723bcc = (element, parent, options = {})=>{
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element)) element = (0, $6348a97baa20d8d9$export$78e3044358792147)(element, parent);
    let { extend: extend, props: props, context: context, __ref: __ref } = element;
    extend = (0, $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315)(extend, context, options);
    const extendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(extend, context);
    if ($3bff1c984b824aeb$var$ENV !== "test" || $3bff1c984b824aeb$var$ENV !== "development") delete element.extend;
    let childExtendStack = [];
    if (parent) {
        element.parent = parent;
        // Assign parent attr to the element
        if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
            childExtendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtend, context);
            const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
            if (parent.childExtendRecursive && !ignoreChildExtendRecursive) {
                const canExtendRecursive = element.key !== "__text";
                if (canExtendRecursive) {
                    const childExtendRecursiveStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtendRecursive, context);
                    // add error if childExtendRecursive contains element which goes to infinite loop
                    childExtendStack = childExtendStack.concat(childExtendRecursiveStack);
                    element.childExtendRecursive = parent.childExtendRecursive;
                }
            }
        }
    }
    const extendLength = extendStack.length;
    const childExtendLength = childExtendStack.length;
    let stack = [];
    if (extendLength && childExtendLength) stack = (0, $ce326eb5cdcc3ce9$export$f9f936cf352c3af2)(extendStack, childExtendStack);
    else if (extendLength) stack = extendStack;
    else if (childExtendLength) stack = childExtendStack;
    else if (!options.extend) return element;
    if (options.extend) {
        const defaultOptionsExtend = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(options.extend, context);
        stack = [].concat(stack, defaultOptionsExtend);
    }
    // check if array contains string extends
    if (__ref) __ref.__extend = stack;
    let mergedExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)(stack);
    // apply `component:` property
    const COMPONENTS = context && context.components || options.components;
    const component = (0, $6348a97baa20d8d9$export$78e3044358792147)(element.component || mergedExtend.component, element);
    if (component && COMPONENTS && COMPONENTS[component]) {
        const componentExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)((0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(COMPONENTS[component]));
        mergedExtend = (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(componentExtend, mergedExtend);
    }
    return (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(element, mergedExtend);
};


"use strict";
const $a6bfc6202982ac85$var$ENV = "production";
const $a6bfc6202982ac85$export$b791484194c5fc38 = (key)=>{
    const isFirstKeyString = (0, $079873fc3f2b5f81$export$844ec244b1367d54)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $a6bfc6202982ac85$export$356ecc5e07374be5 = (newExtend, element)=>{
    const { extend: elementExtend } = element;
    const originalArray = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(newExtend) ? newExtend : [
        newExtend
    ];
    const extend = (0, $d0530a7c3063b815$export$fc359ae9633f7296)(receivedArray, originalArray);
    return {
        ...element,
        extend: extend
    };
};
const $a6bfc6202982ac85$export$c786485ace8eb69b = (element, parent, key)=>{
    const { context: context, tag: tag, extend: extend, props: props, attr: attr, state: state, childExtend: childExtend, childProps: childProps, on: on, if: condition } = element;
    const hasComponentAttrs = extend || childExtend || props || state || on || condition || attr;
    const extendFromKey = key.includes("+") ? key.split("+") : key.includes("_") ? key.split("_")[0] : key.includes(".") ? key.split(".")[0] : key;
    const isExtendKeyComponent = context?.components[extendFromKey];
    if (element === isExtendKeyComponent) return element;
    else if (!hasComponentAttrs || childProps) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...element
        }
    };
    else if (!extend || extend === true) return {
        ...element,
        tag: tag,
        extend: extendFromKey
    };
    else if (extend) return $a6bfc6202982ac85$export$356ecc5e07374be5(extendFromKey, element);
    else if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element)) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...(0, $6348a97baa20d8d9$export$78e3044358792147)(element, parent)
        }
    };
};
const $a6bfc6202982ac85$export$2279e5e6b0817ddc = (element, parent, key)=>{
    return $a6bfc6202982ac85$export$c786485ace8eb69b(element, parent, key) || element;
};
const $a6bfc6202982ac85$export$fd6b2f481ffc7974 = (element, parent, options)=>{
    const { context: context } = element;
    if (!context || !context.components) return;
    const { components: components } = context;
    const { extend: extend } = element;
    const execExtend = (0, $6348a97baa20d8d9$export$78e3044358792147)(extend, element);
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(execExtend)) {
        const componentExists = components[execExtend] || components["smbls." + execExtend];
        if (componentExists) element.extend = componentExists;
        else {
            if (($a6bfc6202982ac85$var$ENV === "test" || $a6bfc6202982ac85$var$ENV === "development") && options.verbose) {
                console.warn(execExtend, "is not in library", components, element);
                console.warn("replacing with ", {});
            }
            element.extend = {};
        }
    }
};
const $a6bfc6202982ac85$export$53cd1a145c393044 = (param)=>{
    if (!(0, $079873fc3f2b5f81$export$844ec244b1367d54)(param)) return;
    const firstCharKey = param.slice(0, 1);
    // return (firstCharKey === '.' || firstCharKey === '$')
    return firstCharKey === ".";
};
const $a6bfc6202982ac85$export$c66af1c05bf7bb06 = (element)=>{
    const { props: props } = element;
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(props) && (0, $079873fc3f2b5f81$export$844ec244b1367d54)(props.variant)) return true;
};
const $a6bfc6202982ac85$export$a9aa73f3ae416cbd = (element, variant, variantProps)=>{
    let variantElement = element[variant];
    if (!variantElement) return;
    const props = (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(variantProps) ? variantProps : {};
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(variantElement)) variantElement = {
        extend: [
            {
                props: props
            },
            variantElement
        ]
    };
    else if (variantElement.extend) variantElement = $a6bfc6202982ac85$export$356ecc5e07374be5({
        props: props
    }, variantElement);
    return (0, $6348a97baa20d8d9$export$f0b277b530b4fffd)(element, (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(variantElement)) // TODO: check why string is not working
    ;
};
const $a6bfc6202982ac85$export$f1439fc936ef702f = (element)=>{
    const { props: props } = element;
    if (!$a6bfc6202982ac85$export$c66af1c05bf7bb06(element)) return element;
    const { variant: variant } = props;
    $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, `.${variant}`);
    const elKeys = Object.keys(element).filter((key)=>$a6bfc6202982ac85$export$53cd1a145c393044(key));
    elKeys.forEach((variant)=>{
        const slicedVariantElementKey = variant.slice(1);
        const variantElementProps = props[slicedVariantElementKey];
        if (variantElementProps) $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, variant, variantElementProps);
    });
    return element;
};


"use strict";



"use strict";
const $0513b3ed7d5404ec$export$3223a9877c540db8 = (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(prop) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = prop;
            element[param] = prop(element, element.state);
        // if (isComponent)
        }
    }
};
const $0513b3ed7d5404ec$export$2ad800d85590910f = (element, options = {
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = ref.__exec[param](element, element.state, element.context);
        const execReturnsString = (0, $079873fc3f2b5f81$export$844ec244b1367d54)(newExec) || (0, $079873fc3f2b5f81$export$7e4aa119212bc614)(newExec);
        // if (prop && prop.node && execReturnsString) {
        if (prop && prop.node && execReturnsString) (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, {
            text: newExec
        }, options);
        else if (newExec !== prop) {
            if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(param)) {
                const { extend: extend, ...newElem } = (0, $a6bfc6202982ac85$export$c786485ace8eb69b)(newExec, element, param);
                (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, newElem, options);
            // } else {
            //   overwrite(prop, newExec, options)
            } else {
                ref.__cached[param] = changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $0513b3ed7d5404ec$export$b4c781127351659b = (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    let defineObj = {};
    const hasGlobalDefine = context && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(context.define);
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(define)) defineObj = {
        ...define
    };
    if (hasGlobalDefine) defineObj = {
        ...defineObj,
        ...context.define
    };
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(elementProp) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = elementProp;
            const execParam = elementProp = (0, $6348a97baa20d8d9$export$78e3044358792147)(elementProp, element);
            if (execParam) {
                elementProp = element[param] = execParam.parse ? execParam.parse() : execParam;
                ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = defineObj[param](elementProp, element, element.state, element.context);
        if (execParam) element[param] = execParam;
    }
    return element;
};
const $0513b3ed7d5404ec$export$88eda8a7eb5c5eff = (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const changes = {};
    let obj = {};
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(define)) obj = {
        ...define
    };
    if ((0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(context && context.define)) obj = {
        ...obj,
        ...context.define
    };
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) ref.__defineCache[param] = execParam(element, element.state, element.context);
        const cached = (0, $6348a97baa20d8d9$export$78e3044358792147)(ref.__defineCache[param], element);
        const newExecParam = obj[param](cached, element, element.state, element.context);
        if (newExecParam) element[param] = newExecParam;
    }
    return changes;
};





"use strict";
const $68d3ab890627ea70$export$535107f3c159da5d = (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = element[param];
    const DOMQLProperty = (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param];
    const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define && element.define[param];
    const hasContextDefine = context && context.define && context.define[param];
    if (!ref.__if) return;
    if (isGlobalTransformer && !hasContextDefine) {
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(isGlobalTransformer)) {
            isGlobalTransformer(prop, element, node, options);
            return;
        }
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};



"use strict";
// import { defineSetter } from './methods'
const $4e214d02be0ddce7$var$ENV = "production";
const $4e214d02be0ddce7$export$270e7ba5936d3c48 = (element, options)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (!ref.__if) return element;
        if (tag === "shadow") node = element.node = element.parent.node.attachShadow({
            mode: "open"
        });
        else node = element.node = (0, $01ef634a92434650$export$257247f9c0329159)(element);
        // trigger `on.attachNode`
        (0, $33936e69aa63c9cd$export$1bc010482b845252)("attachNode", element, options);
    }
    // node.dataset // .key = element.key
    if ($4e214d02be0ddce7$var$ENV === "test" || $4e214d02be0ddce7$var$ENV === "development" || options.alowRefReference) {
        node.ref = element;
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(node.setAttribute)) node.setAttribute("key", element.key);
    }
    // iterate through define
    (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
    // iterate through exec
    (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
    if (element.tag !== "string" && element.tag !== "fragment") // apply events
    {
        if (isNewNode && (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(element.on)) (0, $33936e69aa63c9cd$export$1f7cb486ba1f8a10)(element, options);
    }
    for(const param in element){
        const value = element[param];
        if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(value) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param) || (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param])) continue;
        const isElement = (0, $68d3ab890627ea70$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            if (element[param] && !hasDefine && !hasContextDefine) {
                const createAsync = ()=>(0, $947d5c063e68e91c$export$2e2bcd8739ae039)((0, $6348a97baa20d8d9$export$78e3044358792147)(value, element), element, param, options);
                if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(()=>createAsync());
                else createAsync();
            }
        }
    }
    // node.dataset.key = key
    return element;
};
var $4e214d02be0ddce7$export$2e2bcd8739ae039 = $4e214d02be0ddce7$export$270e7ba5936d3c48;




"use strict";
const $5fc178d8c3a9e6de$export$5c3eb765ea0f1dc2 = {
    key: {},
    tag: {},
    if: {},
    define: {},
    attr: {},
    style: {},
    content: {},
    class: {},
    props: {},
    state: {},
    method: {},
    transform: {},
    on: {},
    ref: {},
    extend: {},
    childExtend: {},
    text: (element, state)=>{
        element.ref.text = {
            tag: "text",
            text: (0, $6348a97baa20d8d9$export$78e3044358792147)(element.text, element, state)
        };
    },
    innerHTML: {},
    set: {},
    update: {},
    remove: {}
} // log: {}
 // value: {},
 // text: {},
 // html: {},
 // path: {},
 // data: {},
 // if: {},
 // __hash: {},
 // __cache: {},
 // __defined: {},
 // __exec: {},
 // __changes: {},
 // __trash: {},
 // __root: {},
 // __props: {},
 // __extend: {},
 // __ifFragment: {},
 // __ifFalsy: {},
 // parent: {},
 // node: {},
 // lookup: {},
 // keys: {},
 // parse: {},
 // parseDeep: {},
;


"use strict";
const $89442055fcdd5e8d$export$de435b1ae0c975f3 = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "html",
        "body",
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};


"use strict";






















"use strict";
const $196ad7400dcaf39e$var$snapshot = {
    snapshotId: (0, $0961ea6318004278$export$6f8fb29fbb5b5b63)
};
const $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
};
const $196ad7400dcaf39e$var$update = function(params = {}, options = $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS) {
    const element = this;
    const { parent: parent, node: node, key: key } = element;
    const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("startUpdate", params, element, options);
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!excludes) (0, $6348a97baa20d8d9$export$4950aa0f605343fb)(options, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS);
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = $196ad7400dcaf39e$var$captureSnapshot(element, options);
    if (snapshotHasUpdated) return;
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(params) || (0, $079873fc3f2b5f81$export$7e4aa119212bc614)(params)) params = {
        text: params
    };
    const inheritState = $196ad7400dcaf39e$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $196ad7400dcaf39e$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__props.filter((v)=>(0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(v));
        const props = params.props || hasParentProps || hasFunctionInProps.length;
        if (props) (0, $902e7fcbfa0a2596$export$c8dce3c08436e91e)(props, element, parent);
    }
    if (!options.preventInitUpdateListener) {
        const initUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initUpdate", params, element, options);
        if (initUpdateReturns === false) return element;
    }
    const overwriteChanges = (0, $6348a97baa20d8d9$export$f0b277b530b4fffd)(element, params, (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d));
    const execChanges = (0, $0513b3ed7d5404ec$export$2ad800d85590910f)(element, {
        ignore: $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    });
    const definedChanges = (0, $0513b3ed7d5404ec$export$88eda8a7eb5c5eff)(element);
    if (!options.isForced) (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    if (options.stackChanges && element.__stackChanges) {
        const stackChanges = (0, $6348a97baa20d8d9$export$4950aa0f605343fb)(definedChanges, (0, $6348a97baa20d8d9$export$4950aa0f605343fb)(execChanges, overwriteChanges));
        element.__stackChanges.push(stackChanges);
    }
    if (!ref.__if) return false;
    if (!node) // return createNode(element, options)
    return;
    for(const param in element){
        const prop = element[param];
        const hasOnlyUpdateFalsy = options.onlyUpdate && (options.onlyUpdate !== param || !element.lookup(options.onlyUpdate));
        const isInPreventUpdate = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(options.preventUpdate) && options.preventUpdate.includes(param);
        const isInPreventDefineUpdate = (0, $079873fc3f2b5f81$export$43bee75e5e14138e)(options.preventDefineUpdate) && options.preventDefineUpdate.includes(param);
        if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(prop) || hasOnlyUpdateFalsy || isInPreventUpdate || isInPreventDefineUpdate || options.preventDefineUpdate === true || options.preventDefineUpdate === param || options.preventContentUpdate && param === "content" || (options.preventStateUpdate && param) === "state" || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) continue;
        if (options.preventStateUpdate === "once") options.preventStateUpdate = false;
        const isElement = (0, $68d3ab890627ea70$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)(prop) && !hasDefine && !hasContextDefine && !options.preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            const childUpdateCall = ()=>$196ad7400dcaf39e$var$update.call(prop, params[prop], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            lazyLoad ? (0, $e33f3b456b841cc9$export$8291e5b88f90ce4).requestAnimationFrame(()=>childUpdateCall()) : childUpdateCall();
        }
    }
    if (!options.preventUpdateListener) (0, $33936e69aa63c9cd$export$1bc010482b845252)("update", element, options);
};
const $196ad7400dcaf39e$var$captureSnapshot = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $196ad7400dcaf39e$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};
const $196ad7400dcaf39e$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = element.if(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.extend;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            element.node?.remove();
            const previousElement = element.previousElement();
            const nextElement = element.nextElement();
            const hasPrevious = previousElement && previousElement.node;
            const hasNext = nextElement && nextElement.node;
            const attachOptions = (hasPrevious?.parentNode || hasNext?.parentNode) && {
                position: hasPrevious ? "after" : hasNext ? "before" : null,
                node: hasPrevious || hasNext
            };
            const created = (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, element.key, (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.on.update)) (0, $33936e69aa63c9cd$export$27ca81ea148fa005)(element.on.update, created, created.state);
            return created;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element based on the specified options.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.execStateFunction] - Execute the state functions.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventInitStateUpdateListener] - If true, prevent the 'initStateUpdated' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdated' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $196ad7400dcaf39e$var$inheritStateUpdates = (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent && parent.state || {};
        return;
    }
    // If state is function, decide execution and apply setting a current state
    const shouldForceFunctionState = (0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $6348a97baa20d8d9$export$78e3044358792147)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            updatedByStateFunction: true
        });
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.initStateUpdated event
    if (!options.preventInitStateUpdateListener) {
        const initStateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdated", keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = $196ad7400dcaf39e$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdated event
    if (!options.preventStateUpdateListener) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdated", newState.parse(), element, options);
};
const $196ad7400dcaf39e$var$createStateUpdate = (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        __stateChildren[child].parent = newState;
    }
    return newState;
};
var $196ad7400dcaf39e$export$2e2bcd8739ae039 = $196ad7400dcaf39e$var$update;




"use strict";
const $6587d89a5cc3b917$export$626ce79af72fc3d3 = (element, parent)=>{
    const proto = {
        set: (0, $bf937aebc888d68f$export$2e2bcd8739ae039).bind(element),
        update: (0, $196ad7400dcaf39e$export$2e2bcd8739ae039).bind(element),
        remove: (0, $d61abc47c39ce5ac$export$cd7f480d6b8286c3).bind(element),
        updateContent: (0, $0a7669919424e35c$export$5143cc956eb9d8f6).bind(element),
        removeContent: (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def).bind(element),
        setProps: (0, $d61abc47c39ce5ac$export$938ca3893886de06).bind(element),
        lookup: (0, $d61abc47c39ce5ac$export$dfc7155ac0343b8).bind(element),
        spotByPath: (0, $d61abc47c39ce5ac$export$cec27f102c074405).bind(element),
        parse: (0, $d61abc47c39ce5ac$export$98e6a39c04603d36).bind(element),
        parseDeep: (0, $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2).bind(element),
        keys: (0, $d61abc47c39ce5ac$export$ed97f33186d4b816).bind(element),
        nextElement: (0, $d61abc47c39ce5ac$export$e87a5caa96444a37).bind(element),
        previousElement: (0, $d61abc47c39ce5ac$export$1facc1d780a4d839).bind(element)
    };
    if ((0, $e6d79d7b0d7b5fe1$export$df77466336fe5355)()) proto.log = (0, $d61abc47c39ce5ac$export$bef1f36f5486a6a3).bind(element);
    Object.setPrototypeOf(element, proto);
};







"use strict";
const $947d5c063e68e91c$var$ENV = "production";
/**
 * Creating a domQL element using passed parameters
 */ const $947d5c063e68e91c$var$create = (element, parent, key, options = (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create || {}, attachOptions)=>{
    $947d5c063e68e91c$var$cacheOptions(element, options);
    // if (key === 'Title') debugger
    // if element is STRING
    if ($947d5c063e68e91c$var$checkIfPrimitive(element)) element = $947d5c063e68e91c$var$applyValueAsText(element, parent, key);
    element = $947d5c063e68e91c$var$redefineElement(element, parent, key, options);
    parent = $947d5c063e68e91c$var$redefineParent(element, parent, key);
    key = $947d5c063e68e91c$var$createKey(element, parent, key);
    const ref = $947d5c063e68e91c$var$addRef(element, parent, key);
    // assign initial props
    ref.__initialProps = (0, $6348a97baa20d8d9$export$b7d58db314e0ac27)(element.props, []);
    // assign context
    $947d5c063e68e91c$var$applyContext(element, parent, options);
    (0, $a6bfc6202982ac85$export$fd6b2f481ffc7974)(element, parent, options);
    if (!ref.__skipCreate) // create EXTEND inheritance
    (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(element, parent, options);
    // create and assign a KEY
    element.key = key;
    // Only resolve extends, skip everything else
    if (options.onlyResolveExtends) return $947d5c063e68e91c$var$onlyResolveExtends(element, parent, key, options);
    $947d5c063e68e91c$var$replaceOptions(element, parent, options);
    $947d5c063e68e91c$var$addCaching(element, parent);
    (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
    $947d5c063e68e91c$var$createScope(element, parent);
    (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    if (element.scope === "state") element.scope = element.state;
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // apply props settings
    (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
    if (element.scope === "props" || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // if it already HAS a NODE
    if (element.node && ref.__if) return (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // apply variants
    (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    const onInit = (0, $33936e69aa63c9cd$export$1bc010482b845252)("init", element, options);
    if (onInit === false) return element;
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    // generate a CLASS name
    (0, $6a43953e96d89b45$export$d559e9a3b71405f6)(element);
    $947d5c063e68e91c$var$renderElement(element, parent, options, attachOptions);
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent);
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("complete", element, options);
    return element;
};
const $947d5c063e68e91c$var$createBasedOnType = (element, parent, key, options)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "element is undefined in", parent && parent.__ref && parent.__ref.path);
        return {};
    }
    if ((0, $079873fc3f2b5f81$export$844ec244b1367d54)(key) && key.slice(0, false)) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "seems like to be in __ref");
    }
    if (element === null) return;
    if (element === true) return {
        text: true
    };
    // if element is extend
    if (element.__hash) return {
        extend: element
    };
    return element;
};
const $947d5c063e68e91c$var$redefineElement = (element, parent, key, options)=>{
    const elementWrapper = $947d5c063e68e91c$var$createBasedOnType(element, parent, key, options);
    if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(key)) return (0, $a6bfc6202982ac85$export$2279e5e6b0817ddc)(elementWrapper, parent, key);
    // TODO: move as define plugins
    // Responsive rendering
    if ($947d5c063e68e91c$var$checkIfMedia(key)) return $947d5c063e68e91c$var$applyMediaProps(elementWrapper, parent, key);
    return elementWrapper;
};
const $947d5c063e68e91c$var$redefineParent = (element, parent, key, options)=>{
    if (!parent) return 0, $80563b8eaf6ba844$export$fbea82a1c0574ef4;
    if ((0, $95800a96be489797$export$8ee0fc9ee280b4ee)(parent)) {
        const parentNodeWrapper = {
            key: ":root",
            node: parent
        };
        (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4)[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $947d5c063e68e91c$var$cacheOptions = (element, options)=>{
    if (options && !(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create) {
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create = options;
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create.context = element.context || options.context;
    }
};
const $947d5c063e68e91c$var$createKey = (element, parent, key)=>{
    return ((0, $6348a97baa20d8d9$export$78e3044358792147)(key, element) || key || element.key || (0, $0961ea6318004278$export$3a7728e868aa3ebd)()).toString();
};
const $947d5c063e68e91c$var$addRef = (element, parent)=>{
    if (element.__ref) element.__ref.origin = element;
    else element.__ref = {
        origin: element
    };
    return element.__ref;
};
const $947d5c063e68e91c$var$replaceOptions = (element, parent, options)=>{
    if (Object.keys(options).length) {
        (0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions = options;
        if (options.ignoreChildExtend) delete options.ignoreChildExtend;
    }
};
const $947d5c063e68e91c$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) parent.__ref.__children.push(element.key);
};
const $947d5c063e68e91c$var$renderElement = (element, parent, options, attachOptions)=>{
    const { __ref: ref, key: key } = element;
    // CREATE a real NODE
    (0, $4e214d02be0ddce7$export$2e2bcd8739ae039)(element, options);
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // run `on.renderRouter`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("renderRouter", element, options);
    // run `on.render`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("render", element, options);
};
const $947d5c063e68e91c$var$checkIfPrimitive = (element)=>{
    return (0, $079873fc3f2b5f81$export$226b3eccf92c9ed9)(element)("string", "number");
};
const $947d5c063e68e91c$var$applyValueAsText = (element, parent, key)=>{
    const extendTag = element.extend && element.extend.tag;
    const childExtendTag = parent.childExtend && parent.childExtend.tag;
    const isKeyValidHTMLTag = (0, $89442055fcdd5e8d$export$de435b1ae0c975f3).body.indexOf(key) > -1 && key;
    return {
        text: element,
        tag: extendTag || childExtendTag || isKeyValidHTMLTag || "string"
    };
};
const $947d5c063e68e91c$var$applyContext = (element, parent, options)=>{
    if (options.context && !(0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context && !element.context) (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context = options.context;
    if (!element.context) element.context = parent.context || options.context || (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context;
};
const $947d5c063e68e91c$var$createScope = (element, parent)=>{
    const { __ref: ref } = element;
    if (!element.scope) element.scope = parent.scope || ref.__root.scope || {};
};
const $947d5c063e68e91c$var$createIfConditionFlag = (element, parent)=>{
    const { __ref: ref } = element;
    if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.if) && !element.if(element, element.state)) delete ref.__if;
    else ref.__if = true;
};
const $947d5c063e68e91c$var$addCaching = (element, parent)=>{
    const { __ref: ref } = element;
    let { __ref: parentRef } = parent;
    // enable TRANSFORM in data
    if (!element.transform) element.transform = {};
    // enable CACHING
    if (!ref.__cached) ref.__cached = {};
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    // Add _root element property
    const hasRoot = parent && parent.key === ":root";
    if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root;
    // set the PATH array
    if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") {
        if (!parentRef) parentRef = parent.ref = {};
        if (!parentRef.__path) parentRef.__path = [];
        ref.__path = parentRef.__path.concat(element.key);
    }
};
const $947d5c063e68e91c$var$onlyResolveExtends = (element, parent, key, options)=>{
    const { __ref: ref } = element;
    if (!ref.__skipCreate) {
        element.tag = (0, $01ef634a92434650$export$5075bd4eae016d2c)(element);
        // if (!element.props) element.props = {}
        // Copy-paste of addCaching()
        // enable CACHING
        if (!ref.__cached) ref.__cached = {};
        if (!ref.__defineCache) ref.__defineCache = {};
        // enable EXEC
        if (!ref.__exec) ref.__exec = {};
        // enable CLASS CACHING
        if (!ref.__class) ref.__class = {};
        if (!ref.__classNames) ref.__classNames = {};
        // enable CLASS CACHING
        if (!ref.__attr) ref.__attr = {};
        // enable CHANGES storing
        if (!ref.__changes) ref.__changes = [];
        // enable CHANGES storing
        if (!ref.__children) ref.__children = [];
        // Add __root element property
        // const hasRoot = parent && parent.key === ':root'
        // if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root
        (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
        (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
        // Borrowed from createIfConditionFlag()
        if ((0, $079873fc3f2b5f81$export$f6e2535fb5126e54)(element.if)) {
            const ifPassed = element.if(element, element.state);
            if (!ifPassed) // const ifFragment = cacheNode({ tag: 'fragment' })
            // ref.__ifFragment = appendNode(ifFragment, parent.node)
            delete ref.__if;
            else ref.__if = true;
        } else ref.__if = true;
        /// ///
        if (element.node && ref.__if) parent[key || element.key] = element;
         // Borrowed from assignNode()
        (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
        if (!element.props) element.props = {};
        (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    }
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
        (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
        for(const k in element){
            if ((0, $079873fc3f2b5f81$export$fce6876652108ab)(element[k]) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(k) || (0, $079873fc3f2b5f81$export$a6cdc56e425d0d0a)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[k]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(k)) continue;
            const hasDefine = element.define && element.define[k];
            const contextHasDefine = element.context && element.context.define && element.context.define[k];
            const optionsHasDefine = options.define && options.define[k];
            if (!ref.__skipCreate && (0, $782cf63e523d0885$export$2e2bcd8739ae039)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $947d5c063e68e91c$var$create((0, $6348a97baa20d8d9$export$78e3044358792147)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by createProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
const $947d5c063e68e91c$var$checkIfMedia = (key)=>key.slice(0, 1) === "@";
const $947d5c063e68e91c$var$applyMediaProps = (element, parent, key)=>{
    const { props: props } = element;
    if (props) {
        props.display = "none";
        if (props[key]) props[key].display = props.display;
        else props[key] = {
            display: props.display || "block"
        };
        return element;
    } else return {
        ...element,
        props: {
            display: "none",
            [key]: {
                display: "block"
            }
        }
    };
};
var $947d5c063e68e91c$export$2e2bcd8739ae039 = $947d5c063e68e91c$var$create;





"use strict";
var $dd5b413a87318846$export$2e2bcd8739ae039 = (params, options = {})=>{
    const { overwrite: overwrite } = options;
    for(const param in params)if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !overwrite) (0, $06908963bda72849$export$f18d5b0af29128b7)("OverwriteToBuiltin", param);
    else (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] = params[param];
};




"use strict";


"use strict";
const $07fce7224ceb45c2$var$create = (element, parent, key, options)=>{
    return (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, key, options);
};
var $07fce7224ceb45c2$export$2e2bcd8739ae039 = {
    TREE: $80563b8eaf6ba844$export$33ecaa422889cd80,
    create: $07fce7224ceb45c2$var$create
};


"use strict";
var { performance: $35da740d59af89ba$var$performance } = window;
var $35da740d59af89ba$var$start = $35da740d59af89ba$var$performance.now();
var $35da740d59af89ba$var$dom = (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).create({
    class: "app",
    proto: (0, $4d894c0568f6ab6a$export$2e2bcd8739ae039)
}, null, "app"); // dom.update({ time: `${performance.now() - start}` })


//# sourceMappingURL=index.16b57466.js.map
